module.exports = __webpack_public_path__ + "static/media/13a.098a37e9.jpg";